import axios from "./axios";
import { buildSearchURL } from "@/utils";
import { SEARCH_BY_OPTIONS } from "@/utils/venueGroups";

const baseUrl = "/api/v3/venue-groups";

const toList = (body) => {
  const list = Array.isArray(body?.items) ? body : body?.data || {};

  return { items: list.items || [], total: list.total || 0 };
};

const toData = (body) => body?.data;

const buildListParams = (params = {}) => {
  const { q, search, limit, offset, ...rest } = params;

  return {
    ...rest,
    search: q || undefined,
    searchBy: q ? search : undefined,
    limit,
    offset,
  };
};

const buildPagination = (total, params = {}, count = 0) => {
  const limit = Number(params.limit) || 10;
  const offset = Number(params.offset) || 0;

  return {
    limit,
    offset,
    total,
    page: Math.floor(offset / limit),
    onPage: count,
    next: total > offset + limit,
    prev: offset !== 0,
  };
};

export default {
  get searchFilters() {
    return SEARCH_BY_OPTIONS.map((option) => ({ ...option }));
  },

  get filtersValues() {
    return ["productType", "health", "vpuVersion", "installationStatus", "lifecycleStatus"];
  },

  getGroups(params) {
    return axios.get(`${baseUrl}${buildSearchURL(buildListParams(params))}`).then((body) => {
      const { items, total } = toList(body);

      return { items, total, pagination: buildPagination(total, params, items.length) };
    });
  },

  getGroup(anchorId) {
    return axios.get(`${baseUrl}/${encodeURIComponent(anchorId)}`).then(toData);
  },

  getAnchorCandidates(params) {
    return axios.get(`${baseUrl}/candidates/anchors${buildSearchURL(params)}`).then(toList);
  },

  getMemberCandidates(params) {
    return axios.get(`${baseUrl}/candidates/members${buildSearchURL(params)}`).then(toList);
  },

  createGroup(anchorId, members) {
    return axios.post(baseUrl, { anchorId, members }).then(toData);
  },

  updateMembers(anchorId, members) {
    return axios.patch(`${baseUrl}/${encodeURIComponent(anchorId)}`, { members }).then(toData);
  },

  ungroup(anchorId) {
    return axios.delete(`${baseUrl}/${encodeURIComponent(anchorId)}`);
  },
};
